export const SET_SIDE_IMAGE = 'SET_SIDE_IMAGE';
export const setSideImage = image => ({ type: SET_SIDE_IMAGE, image });
